import {
  ITEMS_CONTAINER_ACTION_DELETE,
  ITEMS_CONTAINER_ACTION_EDIT,
  ITEMS_CONTAINER_ACTION_VIEW,
  ITEMS_CONTAINER_BULK_ACTION_DELETE,
  ITEMS_CONTAINER_BULK_ACTION_EDIT,
  ITEMS_CONTAINER_BULK_ACTION_EXPORT,
  type PropertiesConfigInputContainerItemUnifiedBulkActionModel,
  type PropertiesConfigInputContainerItemUnifiedRowActionModel,
  UNIFIED_BULK_ACTION_DEFAULT_LABELS,
  UNIFIED_ROW_ACTION_DEFAULT_LABELS,
} from '@blaze-shared/elements-domain';

import { type BulkActionType, type RowActionType } from '../models/actions';

export const STANDARD_RECORD_ACTIONS_MAP = new Map<
  RowActionType,
  PropertiesConfigInputContainerItemUnifiedRowActionModel
>([
  [
    'edit',
    {
      type: 'edit',
      label: UNIFIED_ROW_ACTION_DEFAULT_LABELS.edit,
      id: ITEMS_CONTAINER_ACTION_EDIT,
      icon: 'icon_edit_24',
      showInlineLabel: false,
    },
  ],
  [
    'delete',
    {
      type: 'delete',
      label: UNIFIED_ROW_ACTION_DEFAULT_LABELS.delete,
      id: ITEMS_CONTAINER_ACTION_DELETE,
      icon: 'icon_trash_16',
      showInlineLabel: false,
    },
  ],
  [
    'view',
    {
      type: 'view',
      label: UNIFIED_ROW_ACTION_DEFAULT_LABELS.view,
      id: ITEMS_CONTAINER_ACTION_VIEW,
      icon: 'icon_preview_16',
      showInlineLabel: false,
    },
  ],
]);

export const STANDARD_BULK_ACTIONS_MAP = new Map<
  BulkActionType,
  PropertiesConfigInputContainerItemUnifiedBulkActionModel
>([
  [
    'delete',
    {
      type: 'delete',
      label: UNIFIED_BULK_ACTION_DEFAULT_LABELS.delete,
      id: ITEMS_CONTAINER_BULK_ACTION_DELETE,
      icon: 'icon_trash_16',
      showInlineLabel: false,
    },
  ],
  [
    'export',
    {
      type: 'export',
      label: UNIFIED_BULK_ACTION_DEFAULT_LABELS.export,
      id: ITEMS_CONTAINER_BULK_ACTION_EXPORT,
      icon: 'icon_export_16',
      showInlineLabel: false,
    },
  ],
  [
    'edit',
    {
      type: 'edit',
      label: UNIFIED_BULK_ACTION_DEFAULT_LABELS.edit,
      id: ITEMS_CONTAINER_BULK_ACTION_EDIT,
      icon: 'icon_edit_24',
      showInlineLabel: false,
    },
  ],
]);
